/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Reload_Records_ButtonInputs */



/**
* | output |
* | --- |
* | "Reload Records" |
*
* @param {Automatic_Save_Reload_Records_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_reload_records_button = /** @type {((inputs?: Automatic_Save_Reload_Records_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Reload_Records_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recharger les enregistrements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensätze neu laden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricarica i record")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезагрузить записи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recargar registros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重新加载记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードをリロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड पुनः लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recarregar registros")
	return /** @type {LocalizedString} */ ("Reload Records")
});